import React from "react";

const About = () => {
  return (
    <section
      className="text-gray-600 bg-gray-800 body-font overflow-hidden "
      id="about"
    >
      <div className="container max-w-full px-5 sm:px-6 lg:px-4 lg:py-16 mx-auto">
        <div className="text-center pb-6 text-3xl justify-center item center text-white">
          <h1>About Me</h1>
        </div>
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <img
            alt="ecommerce"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={require("../../assets/aboutme.png").default}
          />
          <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
            <h1 className="text-white text-3xl title-font font-medium mb-1">
              Hi, There!
            </h1>

            <p className="leading-relaxed text-white">
              I'm Yusuf Omari, a front-end and back-end Developer based in Dar
              es Salaam, Tanzania.
              <br />
              I'm passionated about building excellent software that improves
              lives of those who around me. I specialize in creating software
              for clients ranging from individuals and small-businesses all the
              way to large enterprise corporations.
              <br />
              As web developer, I enjoy using my obsessive attention to utileze
              my skill on making things, and my mission-driven work ethic to
              literally change the world.
              <br />
              Beign a deligent and hardworking, I always pride my towards
              achieving best result on each project.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
